/**
 * Checks if the current device is a mobile device.
 * It first attempts to use the modern User-Agent Client Hints API,
 * falling back to traditional user agent string matching.
 */
export function isMobileDevice(): boolean {
  // Try the modern User-Agent Client Hints API first
  if ('userAgentData' in navigator) {
    const userAgentData = (navigator as any).userAgentData
    if (typeof userAgentData?.mobile === 'boolean') {
      return userAgentData.mobile
    }
  }

  // Fallback to traditional user agent string parsing
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
}
